import { MatTableDataSource } from '@angular/material/table';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { CreateSearchDialogComponent } from '../create-search-dialog/create-search-dialog.component';
import { DesicionComponent } from 'src/app/components/dialogs/desicion/desicion.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Graph_Search, NeovisService } from 'src/app/services/neovis.service';

@Component({
  selector: 'app-graph-table',
  templateUrl: './table-search.component.html',
  styleUrls: ['./table-search.component.scss']
})
export class TableGraphComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() search = new EventEmitter<any>();
  displayedColumns: string[] = ['investigationType', 'reference', 'descripcion', 'creado', 'actualizado', 'options'];
  dataSource = null;
  constructor(
    public dialog: MatDialog,
    private neovisService: NeovisService,
    private matPaginatorIntl: MatPaginatorIntl
  ) {

  }

  ngOnInit(): void {
    this.matPaginatorIntl.itemsPerPageLabel = 'Registros por página';
    this.updatenodes();
  }

  updatenodes() {
    this.neovisService.get().subscribe((graph_searchs) => {
      this.dataSource = new MatTableDataSource<Graph_Search>(graph_searchs.reverse())
      this.dataSource.paginator = this.paginator;
    })
  }

  onViewClick(element: any): void {
    // Code to execute when the view icon is clicked goes here
    this.search.emit(element);
  }

  filter: string = ''
  applyFilter(filter) {
    console.log(filter)
    const filterValue = filter;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  createSearch() {
    const dialogref = this.dialog.open(CreateSearchDialogComponent, {
      width: '500px',
      disableClose: true
    });
    dialogref.afterClosed().subscribe((result: Graph_Search) => {
      if (result) {
        const newGraph_Search: Graph_Search = result;
        this.neovisService.create(newGraph_Search).subscribe((graph_search) => {
          this.dataSource.data.unshift(graph_search);
          this.dataSource._updateChangeSubscription();
        })
      }
    });
  }

  delete(element: Graph_Search) {
    const ref = this.dialog.open(DesicionComponent, {
      width: '500px',
      data: {
        text: '¿Está seguro que desea eliminar esta busqueda: "' + element.reference + '"?'
      }
    })
    ref.afterClosed().subscribe((result) => {
      if (result == 'true') {
        this.neovisService.delete(element._id).subscribe((graph_search) => {
          this.neovisService.get().subscribe((graph_searchs) => {
            this.dataSource.data = graph_searchs.reverse()
            this.dataSource.paginator = this.paginator;
            this.dataSource._updateChangeSubscription();
          })
        })

      }
    })
  }
}